export default {
  loading: (state) => state.loading,
  settings: (state) => state.settings,
  lowerFee: (state) => state.lowerFee,
  upperFee: (state) => state.upperFee,
}
